import {
  CaretUpOutlined,
  CheckCircleFilled,
  CheckOutlined,
  ClockCircleFilled,
  CloseCircleFilled,
  CloseOutlined,
  DeleteFilled,
  DollarOutlined,
  EllipsisOutlined,
  LoadingOutlined,
  RedoOutlined,
  StarOutlined,
} from "@ant-design/icons";
import {
  Button,
  Divider,
  Image,
  Input,
  message,
  Modal,
  Popover,
  QRCode,
  Rate,
} from "antd";
import dayjs from "dayjs";
import React, { Fragment, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { THAI_MONTHS, PLAY_MODE_LABELS } from "utils/constants";

import otpImage from "assets/images/png/otp_image.png";
import qrCheckingImage from "assets/images/png/qr_check_in_image.png";
import scanQrImage from "assets/images/png/scan_qr_image.png";
import { QrReader } from "react-qr-reader";
import api from "api";
import CheckinPolicy from "components/policy/checkin";
import CancelPolicy from "components/policy/cancel";

let timer = null;
let api_polling_rate = 4;

export default function JobCard({
  GetBookingList,
  setIsLoading,
  booking,
  userData,
  status_key,
  onClickDelete,
  setIsAcceptOrReject,
  setBookingToAcceptOrReject,
  handeClickCancelJob,
  calculateDeductMoney,
}) {
  const naviage = useNavigate();

  const [isCancel, setIsCancel] = useState(false);
  const [isCheckIn, setIsCheckIn] = useState(false);

  const [verifyMethod, setVerifyMethod] = useState(0);
  const [otpNumber, setOTPNumber] = useState(null);
  const [otpNumberError, setOTPNumberError] = useState(false);
  const [verifyData, setVerifyData] = useState(null);

  const [messageApi, contextHolder] = message.useMessage();

  const [isScanning, setIsScanning] = useState(false);

  const badge_status = {
    0: {
      icon: <DollarOutlined />,
      color: "#EC9D1F",
      label: "รอชำระเงิน",
    },
    1: {
      icon: <></>,
      color: "#1F7EEC",
      label: "รอตรวจสอบ",
    },
    2: {
      icon: <CaretUpOutlined />,
      color: "#14AE5C",
      label: "ที่กำลังจะมาถึง",
    },
    3: {
      icon: <></>,
      color: "#EC221F",
      label: "ถูกยกเลิก",
    },
    4: {
      icon: <CheckOutlined />,
      color: "#757575",
      label: "สำเร็จ",
    },
    5: {
      icon: <></>,
      color: "#EC221F",
      label: "ถูกยกเลิกหลังจากชำระเงิน",
    },
    6: {
      icon: <DollarOutlined />,
      color: "#D89F42",
      label: "รอรับเงินคืน",
    },
    7: {
      icon: <></>,
      color: "#63558A",
      label: "คืนเงินแล้ว",
    },
  };

  const navigate = useNavigate();

  const cancel_content = () => (
    <div
      onClick={() => setIsCancel(true)}
      style={{
        cursor: "pointer",
        display: "flex",
        gap: 10,
        alignItems: "center",
        padding: 10,
        border: "2px solid #d5d5d580",
        borderRadius: 10,
      }}
    >
      <CloseOutlined style={{ fontSize: 20, color: "red" }} />
      <div>{userData.user_type === 0 ? "ยกเลิกงาน" : "ยกเลิกการจอง"}</div>
    </div>
  );

  const CancelModal = () => (
    <Modal
      open={isCancel}
      centered
      footer={false}
      onCancel={() => setIsCancel(false)}
      styles={{
        content: {
          borderRadius: 16,
          padding: 0,
          overflow: "hidden",
          boxShadow: "0 15px 30px rgba(169, 51, 70, 0.15)",
          maxWidth: 420,
        },
      }}
    >
      <div
        style={{
          background: "linear-gradient(135deg, #a93346 0%, #d63384 100%)",
          padding: "20px 20px 16px",
          position: "relative",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            position: "absolute",
            top: -15,
            right: -15,
            width: 60,
            height: 60,
            borderRadius: "50%",
            background: "rgba(255, 255, 255, 0.1)",
          }}
        />
        <div
          style={{
            position: "absolute",
            bottom: -20,
            left: -20,
            width: 70,
            height: 70,
            borderRadius: "50%",
            background: "rgba(255, 255, 255, 0.05)",
          }}
        />

        <div style={{ textAlign: "center", position: "relative", zIndex: 1 }}>
          <div
            style={{
              width: 56,
              height: 56,
              borderRadius: "50%",
              backgroundColor: "rgba(255, 255, 255, 0.2)",
              backdropFilter: "blur(10px)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "0 auto 12px",
              border: "2px solid rgba(255, 255, 255, 0.3)",
            }}
          >
            <CloseOutlined style={{ fontSize: 24, color: "white" }} />
          </div>
          <h2
            style={{
              color: "white",
              fontSize: 20,
              fontWeight: 600,
              margin: 0,
              lineHeight: 1.4,
              textShadow: "0 2px 4px rgba(0,0,0,0.2)",
            }}
          >
            {userData.user_type === 0 ? "ยกเลิกงาน" : "ยกเลิกการจอง"}
          </h2>
        </div>
      </div>

      <div style={{ padding: "20px" }}>
        <div
          style={{
            background: "linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%)",
            borderRadius: 12,
            padding: 16,
            marginBottom: 16,
            border: "1px solid #e9ecef",
            boxShadow: "0 4px 12px rgba(169, 51, 70, 0.08)",
          }}
        >
          <div style={{ fontSize: 15, lineHeight: 1.6 }}>
            <div
              style={{
                marginBottom: 12,
                paddingBottom: 12,
                borderBottom: "2px solid #f1f3f4",
                display: "flex",
                alignItems: "center",
                gap: 10,
              }}
            >
              <div
                style={{
                  width: 6,
                  height: 6,
                  borderRadius: "50%",
                  backgroundColor: "#a93346",
                }}
              />
              <span style={{ fontWeight: 500, color: "#6c757d", fontSize: 14 }}>
                {booking?.data?.user?.user_type === 0 ? "Caddy" : "Golfer"} :
              </span>
              <span style={{ fontWeight: 700, color: "#212529", fontSize: 16 }}>
                {booking?.data?.user?.display_name}
              </span>
            </div>

            {booking?.tf_time && (
              <div style={{ marginBottom: 12 }}>
                <div
                  style={{
                    marginBottom: 8,
                    display: "flex",
                    alignItems: "center",
                    gap: 6,
                  }}
                >
                  <span
                    style={{ fontWeight: 600, color: "#a93346", fontSize: 14 }}
                  >
                    📅 วันที่ ทีออฟ :{" "}
                  </span>
                  <span
                    style={{ fontWeight: 600, color: "#212529", fontSize: 14 }}
                  >
                    {dayjs(booking?.tf_time).format("DD")}{" "}
                    {
                      THAI_MONTHS[
                        parseInt(dayjs(booking?.tf_time).format("MM")) - 1
                      ]
                    }{" "}
                    {dayjs(booking?.tf_time).format("YYYY")}
                  </span>
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 6,
                  }}
                >
                  <span
                    style={{ fontWeight: 600, color: "#a93346", fontSize: 14 }}
                  >
                    ⏰ เวลา ทีออฟ :{" "}
                  </span>
                  <span
                    style={{ fontWeight: 600, color: "#212529", fontSize: 14 }}
                  >
                    {dayjs(booking?.tf_time, "YYYY-MM-DD HH:mm:ss")
                      .add(7, "hours")
                      .format("HH:mm")}{" "}
                    -{" "}
                    {dayjs(booking?.tf_time, "YYYY-MM-DD HH:mm:ss")
                      .add(13, "hours")
                      .format("HH:mm")}{" "}
                    น.
                  </span>
                </div>
              </div>
            )}

            {userData?.user_type === 1 && (
              <>
                <div
                  style={{
                    background:
                      "linear-gradient(135deg, #e8f5e8 0%, #f3f9f3 100%)",
                    borderRadius: 10,
                    padding: 12,
                    marginBottom: 8,
                    border: "2px solid #07C756",
                    position: "relative",
                    overflow: "hidden",
                  }}
                >
                  <div
                    style={{
                      position: "absolute",
                      top: -8,
                      right: -8,
                      width: 30,
                      height: 30,
                      borderRadius: "50%",
                      background: "rgba(7, 199, 86, 0.1)",
                    }}
                  />
                  <div
                    style={{
                      fontSize: 18,
                      fontWeight: 700,
                      color: "#07C756",
                      textAlign: "center",
                      position: "relative",
                      zIndex: 1,
                    }}
                  >
                    💰 ทิป{" "}
                    {new Intl.NumberFormat("th-TH", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    }).format(booking?.grand_total)}{" "}
                    บาท
                  </div>
                </div>

                <div
                  style={{
                    background:
                      "linear-gradient(135deg, #ffebee 0%, #fce4ec 100%)",
                    borderRadius: 10,
                    padding: 12,
                    marginBottom: 8,
                    border: "2px solid #a93346",
                    position: "relative",
                    overflow: "hidden",
                  }}
                >
                  <div
                    style={{
                      position: "absolute",
                      top: -10,
                      right: -10,
                      width: 35,
                      height: 35,
                      borderRadius: "50%",
                      background: "rgba(169, 51, 70, 0.1)",
                    }}
                  />
                  <div
                    style={{
                      fontSize: 18,
                      fontWeight: 700,
                      color: "#a93346",
                      textAlign: "center",
                      marginBottom: 6,
                      position: "relative",
                      zIndex: 1,
                    }}
                  >
                    💸 คืนเงิน{" "}
                    {new Intl.NumberFormat("th-TH", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    }).format(
                      calculateDeductMoney(booking) < 0
                        ? 0
                        : calculateDeductMoney(booking),
                    )}{" "}
                    บาท
                  </div>
                  <div
                    style={{
                      fontSize: 11,
                      color: "#8c8c8c",
                      textAlign: "center",
                      lineHeight: 1.4,
                      fontWeight: 500,
                      position: "relative",
                      zIndex: 1,
                    }}
                  >
                    ทิป (
                    {new Intl.NumberFormat("th-TH", {
                      minimumFractionDigits: 0,
                      maximumFractionDigits: 0,
                    }).format(booking?.grand_total)}
                    ) - (ค่าบริการ (
                    {new Intl.NumberFormat("th-TH", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    }).format(booking?.transaction_fee)}
                    ) + Vat 7% (
                    {new Intl.NumberFormat("th-TH", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    }).format(booking?.vat)}
                    ))
                  </div>
                </div>
              </>
            )}
          </div>
        </div>

        {/* Enhanced Warning */}
        <div
          style={{
            background: "linear-gradient(135deg, #fff8e1 0%, #fffde7 100%)",
            border: "2px solid #ffb74d",
            borderRadius: 10,
            padding: 14,
            marginBottom: 18,
            textAlign: "center",
            position: "relative",
            overflow: "hidden",
          }}
        >
          <div
            style={{
              position: "absolute",
              top: -15,
              left: "50%",
              transform: "translateX(-50%)",
              width: 45,
              height: 45,
              borderRadius: "50%",
              background: "rgba(255, 183, 77, 0.2)",
            }}
          />
          <div
            style={{
              color: "#ef6c00",
              fontWeight: 700,
              fontSize: 14,
              lineHeight: 1.4,
              position: "relative",
              zIndex: 1,
            }}
          >
            ⚠️ หากทำการยกเลิกแล้วจะไม่สามารถแก้ไขได้
          </div>
        </div>

        {/* Action Buttons */}
        <div style={{ display: "flex", gap: 10 }}>
          <Button
            style={{
              width: "100%",
              height: 44,
              borderRadius: 10,
              fontSize: 15,
              fontWeight: 600,
              background: "linear-gradient(135deg, #a93346 0%, #d63384 100%)",
              border: "none",
              boxShadow: "0 4px 12px rgba(169, 51, 70, 0.3)",
              color: "white",
              transition: "all 0.3s ease",
            }}
            onClick={() => {
              handeClickCancelJob(booking);
              setIsCancel(false);
            }}
            onMouseEnter={(e) => {
              e.target.style.transform = "translateY(-2px)";
              e.target.style.boxShadow = "0 6px 16px rgba(169, 51, 70, 0.4)";
            }}
            onMouseLeave={(e) => {
              e.target.style.transform = "translateY(0)";
              e.target.style.boxShadow = "0 4px 12px rgba(169, 51, 70, 0.3)";
            }}
          >
            ใช่, ยกเลิกเลย
          </Button>
          <Button
            style={{
              width: "100%",
              height: 44,
              borderRadius: 10,
              fontSize: 15,
              fontWeight: 600,
              background: "linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)",
              border: "2px solid #dee2e6",
              color: "#495057",
              boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
              transition: "all 0.3s ease",
            }}
            onClick={() => setIsCancel(false)}
            onMouseEnter={(e) => {
              e.target.style.transform = "translateY(-2px)";
              e.target.style.boxShadow = "0 4px 12px rgba(0,0,0,0.15)";
            }}
            onMouseLeave={(e) => {
              e.target.style.transform = "translateY(0)";
              e.target.style.boxShadow = "0 2px 8px rgba(0,0,0,0.08)";
            }}
          >
            ปิด
          </Button>
        </div>
        {/* <CancelPolicy /> */}
      </div>
    </Modal>
  );

  function QrCodePage() {
    return (
      <div
        style={{
          background: "linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%)",
          borderRadius: 20,
          padding: "24px",
          position: "relative",
          overflow: "hidden",
        }}
      >
        {/* Decorative elements */}
        <div
          style={{
            position: "absolute",
            top: -30,
            right: -30,
            width: 80,
            height: 80,
            borderRadius: "50%",
            background: "linear-gradient(135deg, #a93346 0%, #d63384 100%)",
            opacity: 0.1,
          }}
        />
        <div
          style={{
            position: "absolute",
            bottom: -20,
            left: -20,
            width: 60,
            height: 60,
            borderRadius: "50%",
            background: "linear-gradient(135deg, #07C756 0%, #28a745 100%)",
            opacity: 0.1,
          }}
        />

        {/* Header */}
        <div
          style={{
            textAlign: "center",
            marginBottom: 24,
            position: "relative",
            zIndex: 1,
          }}
        >
          <div
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: 10,
              background: "linear-gradient(135deg, #a93346 0%, #d63384 100%)",
              color: "white",
              padding: "8px 16px",
              borderRadius: 20,
              fontSize: 18,
              fontWeight: 600,
              boxShadow: "0 4px 12px rgba(169, 51, 70, 0.3)",
            }}
          >
            เช็คอิน
          </div>
          <div
            style={{
              fontSize: 16,
              color: "#6c757d",
              marginTop: 8,
              fontWeight: 500,
            }}
          >
            Scan QR Code
          </div>
        </div>

        {userData.user_type === 0 ? (
          verifyData?.is_otp ? (
            <div
              style={{
                textAlign: "center",
                background: "linear-gradient(135deg, #ffebee 0%, #fce4ec 100%)",
                borderRadius: 16,
                padding: 24,
                border: "2px solid #ffcdd2",
                position: "relative",
                zIndex: 1,
              }}
            >
              <div
                style={{
                  fontSize: 48,
                  marginBottom: 16,
                }}
              >
                🚫
              </div>
              <div
                style={{
                  color: "#a93346",
                  fontSize: 20,
                  fontWeight: 700,
                  marginBottom: 12,
                }}
              >
                ไม่พบ QR Code
              </div>
              <div
                style={{
                  color: "#6c757d",
                  fontSize: 16,
                  lineHeight: 1.5,
                }}
              >
                กรุณาให้นักกอล์ฟกดขอ QR Code ก่อนยืนยัน
              </div>
            </div>
          ) : (
            <div style={{ position: "relative", zIndex: 1 }}>
              {isScanning ? (
                <div
                  style={{
                    textAlign: "center",
                    background:
                      "linear-gradient(135deg, #e8f5e8 0%, #f3f9f3 100%)",
                    borderRadius: 16,
                    padding: 32,
                    border: "2px solid #07C756",
                  }}
                >
                  <div
                    style={{
                      fontSize: 48,
                      marginBottom: 16,
                      animation: "pulse 2s infinite",
                    }}
                  >
                    🔄
                  </div>
                  <div
                    style={{
                      fontSize: 20,
                      color: "#07C756",
                      fontWeight: 600,
                    }}
                  >
                    <LoadingOutlined style={{ marginRight: 8 }} />
                    กำลังยืนยันการเช็คอิน
                  </div>
                </div>
              ) : (
                <>
                  {timeLeft?.seconds !== 0 || timeLeft?.minutes !== 0 ? (
                    <div
                      style={{
                        width: "100%",
                        paddingTop: "100%",
                        marginBottom: 16,
                        background: "#000",
                        borderRadius: 16,
                        overflow: "hidden",
                        position: "relative",
                      }}
                    >
                      <div
                        style={{
                          position: "absolute",
                          top: 0,
                          left: 0,
                          width: "100%",
                          height: "100%",
                        }}
                      >
                        <QrReader
                          constraints={{
                            facingMode: "environment",
                            advanced: [{ zoom: { ideal: 4 } }],
                          }}
                          onResult={(resp, error) => {
                            if (resp) {
                              setIsScanning(true);
                              let result = null;
                              try {
                                result = JSON?.parse(resp?.text)
                                  ? JSON.parse(resp?.text)
                                  : null;
                              } catch (err) {
                                result = null;
                              }
                              handleOnVerifyQRCode(result);
                            }
                          }}
                          style={{
                            width: "100%",
                            height: "100%",
                          }}
                          videoStyle={{
                            objectFit: "cover",
                          }}
                        />
                        <div
                          style={{
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            width: "70%",
                            paddingTop: "70%",
                            border: "3px solid #07C756",
                            borderRadius: 12,
                            boxShadow: "0 0 0 9999px rgba(0, 0, 0, 0.5)",
                            pointerEvents: "none",
                          }}
                        />
                      </div>
                    </div>
                  ) : null}

                  <div
                    style={{
                      textAlign: "center",
                      background:
                        "linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)",
                      borderRadius: 12,
                      padding: 16,
                      border: "1px solid #dee2e6",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 8,
                        fontSize: 14,
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: 8,
                          fontWeight: 600,
                          color: "#495057",
                        }}
                      >
                        🔑 <span>Ref Code : {verifyData?.otp_ref}</span>
                      </div>
                      {timeLeft?.seconds === 0 && timeLeft?.minutes === 0 ? (
                        <div
                          style={{
                            color: "#a93346",
                            fontWeight: 700,
                            fontSize: 12,
                            padding: "8px 16px",
                            background:
                              "linear-gradient(135deg, #ffebee 0%, #fce4ec 100%)",
                            borderRadius: 8,
                            border: "1px solid #ffcdd2",
                          }}
                        >
                          ไม่พบ QR Code กรุณาให้นักกอล์ฟ
                        </div>
                      ) : (
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: 8,
                            fontWeight: 600,
                            color:
                              timeLeft?.minutes < 2 ? "#a93346" : "#495057",
                            padding: "8px 12px",
                            background:
                              timeLeft?.minutes < 2
                                ? "linear-gradient(135deg, #fff8e1 0%, #fffde7 100%)"
                                : "transparent",
                            borderRadius: 8,
                            border:
                              timeLeft?.minutes < 2
                                ? "1px solid #ffb74d"
                                : "none",
                          }}
                        >
                          <span style={{ fontSize: 12 }}>
                            เช็คอินภายใน :{" "}
                            {timeLeft?.minutes?.toString()?.padStart(2, "0")}{" "}
                            นาที{" "}
                            {timeLeft?.seconds?.toString()?.padStart(2, "0")}{" "}
                            วินาที
                          </span>
                        </div>
                      )}
                    </div>
                  </div>
                </>
              )}
            </div>
          )
        ) : verifyData && timeLeft ? (
          <div style={{ textAlign: "center", position: "relative", zIndex: 1 }}>
            {/* QR Code Display for Golfer */}
            <div
              style={{
                background: "linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)",
                borderRadius: 16,
                padding: 24,
                marginBottom: 20,
                border: "2px solid #dee2e6",
                boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
                position: "relative",
                overflow: "hidden",
              }}
            >
              <div
                style={{
                  position: "absolute",
                  top: -10,
                  right: -10,
                  width: 40,
                  height: 40,
                  borderRadius: "50%",
                  background: "rgba(7, 199, 86, 0.1)",
                }}
              />
              <div
                style={{
                  fontSize: 16,
                  fontWeight: 600,
                  color: "#07C756",
                  marginBottom: 16,
                  position: "relative",
                  zIndex: 1,
                }}
              >
                QR Code ของคุณ
              </div>
              <div style={{ position: "relative", zIndex: 1 }}>
                <QRCode
                  onRefresh={() => {
                    setIsLoading(true);
                    createCaddyQrCode();
                  }}
                  style={{
                    margin: "0 auto",
                    borderRadius: 12,
                    overflow: "hidden",
                    boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                  }}
                  status={
                    timeLeft?.seconds === 0 && timeLeft?.minutes === 0
                      ? "expired"
                      : "active"
                  }
                  value={verifyData ? JSON.stringify(verifyData) : "-"}
                />
              </div>
            </div>

            {/* Warning for Golfer */}
            <div
              style={{
                background: "linear-gradient(135deg, #fff8e1 0%, #fffde7 100%)",
                border: "2px solid #ffb74d",
                borderRadius: 12,
                padding: 8,
                marginBottom: 20,
              }}
            >
              <div
                style={{
                  color: "#ef6c00",
                  fontSize: 12,
                  fontWeight: 600,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 8,
                }}
              >
                กรุณาเปิดหน้าจอไว้ระหว่างแคดดี้สแกน
              </div>
            </div>

            {/* Info Section */}
            <div
              style={{
                background: "linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)",
                borderRadius: 12,
                padding: 12,
                border: "1px solid #dee2e6",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 8,
                  fontSize: 14,
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: 8,
                    fontWeight: 600,
                    color: "#495057",
                  }}
                >
                  🔑 <span>Ref Code : {verifyData?.otp_ref}</span>
                </div>
                {timeLeft?.seconds === 0 && timeLeft?.minutes === 0 ? (
                  <div
                    style={{
                      color: "#a93346",
                      fontWeight: 700,
                      fontSize: 16,
                      padding: "8px 16px",
                      background:
                        "linear-gradient(135deg, #ffebee 0%, #fce4ec 100%)",
                      borderRadius: 8,
                      border: "1px solid #ffcdd2",
                    }}
                  >
                    ไม่พบ QR Code กรุณาให้นักกอล์ฟ
                  </div>
                ) : (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: 8,
                      fontWeight: 600,
                      color: timeLeft?.minutes < 2 ? "#a93346" : "#495057",
                      padding: "8px 16px",
                      background:
                        timeLeft?.minutes < 2
                          ? "linear-gradient(135deg, #fff8e1 0%, #fffde7 100%)"
                          : "transparent",
                      borderRadius: 8,
                      border:
                        timeLeft?.minutes < 2 ? "1px solid #ffb74d" : "none",
                    }}
                  >
                    <span style={{ fontSize: 12 }}>
                      เช็คอินภายใน :{" "}
                      {timeLeft?.minutes?.toString()?.padStart(2, "0")} นาที{" "}
                      {timeLeft?.seconds?.toString()?.padStart(2, "0")} วินาที
                    </span>
                  </div>
                )}
              </div>
            </div>
          </div>
        ) : (
          <div
            style={{
              textAlign: "center",
              background: "linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)",
              borderRadius: 16,
              padding: 32,
              border: "1px solid #dee2e6",
              position: "relative",
              zIndex: 1,
            }}
          >
            <div
              style={{
                fontSize: 18,
                color: "#495057",
                fontWeight: 500,
              }}
            >
              <LoadingOutlined style={{ marginRight: 8 }} />
              กำลังโหลด QR Code...
            </div>
          </div>
        )}
      </div>
    );
  }

  const calculateTimeLeft = () => {
    const now = new Date();
    const target = new Date(verifyData?.verify_expire);
    const difference = target - now;

    if (difference > 0) {
      const minutes = Math.floor((difference / 1000 / 60) % 60);
      const seconds = Math.floor((difference / 1000) % 60);

      if (seconds % api_polling_rate === 0) {
        getJobData();
      }

      return { minutes, seconds };
    } else {
      clearInterval(timer);
      return { minutes: 0, seconds: 0 };
    }
  };

  const [timeLeft, setTimeLeft] = useState(null);

  useEffect(() => {
    if (verifyData) {
      timer = setInterval(() => {
        setTimeLeft(calculateTimeLeft());
      }, 1000);
    }

    return () => clearInterval(timer);
  }, [verifyData]);

  async function getJobData() {
    try {
      const { data, status } = await api.bookingApi.getBooking(booking?.id);
      const info = data?.data;
      if (status === 200 && info.is_verify) {
        clearInterval(timer);
        GetBookingList();
        setVerifyMethod(3);
      }
    } catch (error) {
      console.log("error", error);
    }
  }

  function OTPPage() {
    return (
      <div
        style={{
          background: "linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%)",
          borderRadius: 20,
          padding: "24px",
          position: "relative",
          overflow: "hidden",
        }}
      >
        {/* Decorative elements */}
        <div
          style={{
            position: "absolute",
            top: -30,
            right: -30,
            width: 80,
            height: 80,
            borderRadius: "50%",
            background: "linear-gradient(135deg, #a93346 0%, #d63384 100%)",
            opacity: 0.1,
          }}
        />
        <div
          style={{
            position: "absolute",
            bottom: -20,
            left: -20,
            width: 60,
            height: 60,
            borderRadius: "50%",
            background: "linear-gradient(135deg, #07C756 0%, #28a745 100%)",
            opacity: 0.1,
          }}
        />

        {/* Header */}
        <div
          style={{
            textAlign: "center",
            marginBottom: 24,
            position: "relative",
            zIndex: 1,
          }}
        >
          <div
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: 10,
              background: "linear-gradient(135deg, #a93346 0%, #d63384 100%)",
              color: "white",
              padding: "8px 16px",
              borderRadius: 20,
              fontSize: 18,
              fontWeight: 600,
              boxShadow: "0 4px 12px rgba(169, 51, 70, 0.3)",
            }}
          >
            🔐 เช็คอิน
          </div>
          <div
            style={{
              fontSize: 16,
              color: "#6c757d",
              marginTop: 8,
              fontWeight: 500,
            }}
          >
            หมายเลข OTP
          </div>
        </div>

        {userData.user_type === 0 ? (
          !verifyData?.is_otp ||
          (verifyData && verifyData?.otp_ref === null) ? (
            <div
              style={{
                textAlign: "center",
                background: "linear-gradient(135deg, #ffebee 0%, #fce4ec 100%)",
                borderRadius: 16,
                padding: 24,
                border: "2px solid #ffcdd2",
                position: "relative",
                zIndex: 1,
              }}
            >
              <div
                style={{
                  fontSize: 48,
                  marginBottom: 16,
                }}
              >
                🚫
              </div>
              <div
                style={{
                  color: "#a93346",
                  fontSize: 20,
                  fontWeight: 700,
                  marginBottom: 12,
                }}
              >
                ไม่พบรหัส OTP
              </div>
              <div
                style={{
                  color: "#6c757d",
                  fontSize: 16,
                  lineHeight: 1.5,
                }}
              >
                กรุณาให้นักกอล์ฟกดขอ OTP ก่อนยืนยัน
              </div>
            </div>
          ) : timeLeft?.seconds === 0 && timeLeft?.minutes === 0 ? (
            <div
              style={{
                textAlign: "center",
                background: "linear-gradient(135deg, #ffebee 0%, #fce4ec 100%)",
                borderRadius: 16,
                padding: 24,
                border: "2px solid #ffcdd2",
                position: "relative",
                zIndex: 1,
              }}
            >
              <div
                style={{
                  fontSize: 48,
                  marginBottom: 16,
                }}
              >
                ⏰
              </div>
              <div
                style={{
                  color: "#a93346",
                  fontSize: 20,
                  fontWeight: 700,
                  marginBottom: 12,
                }}
              >
                OTP หมดอายุ
              </div>
              <div
                style={{
                  color: "#6c757d",
                  fontSize: 16,
                  lineHeight: 1.5,
                }}
              >
                กรุณาให้นักกอล์ฟกดขอ OTP ใหม่อีกครั้ง
              </div>
            </div>
          ) : verifyData && timeLeft ? (
            <div
              style={{ textAlign: "center", position: "relative", zIndex: 1 }}
            >
              {/* OTP Input Section */}
              <div
                style={{
                  background:
                    "linear-gradient(135deg, #fff8e1 0%, #fffde7 100%)",
                  borderRadius: 16,
                  padding: 20,
                  marginBottom: 20,
                  border: "2px solid #ffb74d",
                }}
              >
                <div
                  style={{
                    fontSize: 16,
                    fontWeight: 600,
                    color: "#ef6c00",
                    marginBottom: 16,
                  }}
                >
                  กรอกรหัส OTP
                </div>
                <Input.OTP
                  type="number"
                  length={3}
                  size="large"
                  onChange={(e) => {
                    setOTPNumber(e);
                    setOTPNumberError(false);
                  }}
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    gap: 12,
                  }}
                />
                {otpNumberError && (
                  <div
                    style={{
                      color: "#a93346",
                      fontSize: 14,
                      fontWeight: 500,
                      marginTop: 12,
                    }}
                  >
                    ⚠️ กรุณากรอกหมายเลข OTP
                  </div>
                )}
              </div>

              {/* OTP Display */}
              <div
                style={{
                  background:
                    "linear-gradient(135deg, #e8f5e8 0%, #f3f9f3 100%)",
                  borderRadius: 16,
                  padding: 24,
                  marginBottom: 20,
                  border: "2px solid #07C756",
                  position: "relative",
                  overflow: "hidden",
                }}
              >
                <div
                  style={{
                    position: "absolute",
                    top: -10,
                    right: -10,
                    width: 40,
                    height: 40,
                    borderRadius: "50%",
                    background: "rgba(7, 199, 86, 0.2)",
                  }}
                />
                <div
                  style={{
                    fontSize: 16,
                    fontWeight: 600,
                    color: "#07C756",
                    marginBottom: 16,
                    position: "relative",
                    zIndex: 1,
                  }}
                >
                  รหัส OTP ของคุณ
                </div>
                <div
                  style={{
                    fontSize: 56,
                    fontWeight: 800,
                    color: "#07C756",
                    letterSpacing: "8px",
                    textShadow: "0 2px 4px rgba(7, 199, 86, 0.3)",
                    position: "relative",
                    zIndex: 1,
                  }}
                >
                  {verifyData?.otp}
                </div>
              </div>

              <Button
                type="primary"
                size="large"
                style={{
                  width: "100%",
                  height: 56,
                  borderRadius: 16,
                  fontSize: 18,
                  fontWeight: 600,
                  background:
                    "linear-gradient(135deg, #a93346 0%, #d63384 100%)",
                  border: "none",
                  boxShadow: "0 6px 16px rgba(169, 51, 70, 0.3)",
                  marginBottom: 20,
                }}
                onClick={handleOnVerifyOTP}
                onMouseEnter={(e) => {
                  e.target.style.transform = "translateY(-2px)";
                  e.target.style.boxShadow =
                    "0 8px 20px rgba(169, 51, 70, 0.4)";
                }}
                onMouseLeave={(e) => {
                  e.target.style.transform = "translateY(0)";
                  e.target.style.boxShadow =
                    "0 6px 16px rgba(169, 51, 70, 0.3)";
                }}
              >
                เช็คอิน
              </Button>

              <div
                style={{
                  background:
                    "linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)",
                  borderRadius: 12,
                  padding: 16,
                  border: "1px solid #dee2e6",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 8,
                    fontSize: 14,
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: 8,
                      fontWeight: 600,
                      color: "#495057",
                    }}
                  >
                    🔑 <span>Ref Code : {verifyData?.otp_ref}</span>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: 8,
                      fontWeight: 600,
                      color: timeLeft?.minutes < 2 ? "#a93346" : "#495057",
                    }}
                  >
                    <span style={{ fontSize: 12 }}>
                      เช็คอินภายใน :{" "}
                      {timeLeft?.minutes?.toString()?.padStart(2, "0")} นาที{" "}
                      {timeLeft?.seconds?.toString()?.padStart(2, "0")} วินาที
                    </span>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div
              style={{
                textAlign: "center",
                background: "linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)",
                borderRadius: 16,
                padding: 32,
                border: "1px solid #dee2e6",
                position: "relative",
                zIndex: 1,
              }}
            >
              <div
                style={{
                  fontSize: 18,
                  color: "#495057",
                  fontWeight: 500,
                }}
              >
                <LoadingOutlined style={{ marginRight: 8 }} />
                กำลังโหลดหมายเลข OTP...
              </div>
            </div>
          )
        ) : timeLeft ? (
          timeLeft.seconds === 0 && timeLeft.minutes === 0 ? (
            <div
              style={{
                textAlign: "center",
                background: "linear-gradient(135deg, #ffebee 0%, #fce4ec 100%)",
                borderRadius: 16,
                padding: 24,
                border: "2px solid #ffcdd2",
                position: "relative",
                zIndex: 1,
              }}
            >
              <div
                style={{
                  fontSize: 48,
                  marginBottom: 16,
                }}
              >
                ⏰
              </div>
              <div
                style={{
                  color: "#a93346",
                  fontSize: 20,
                  fontWeight: 700,
                  marginBottom: 12,
                }}
              >
                OTP หมดอายุ
              </div>
              <div
                style={{
                  color: "#6c757d",
                  fontSize: 16,
                  lineHeight: 1.5,
                }}
              >
                กรุณาลองใหม่อีกครั้ง
              </div>
            </div>
          ) : (
            <div
              style={{ textAlign: "center", position: "relative", zIndex: 1 }}
            >
              {/* OTP Display for Golfer */}
              <div
                style={{
                  background:
                    "linear-gradient(135deg, #e8f5e8 0%, #f3f9f3 100%)",
                  borderRadius: 16,
                  padding: 32,
                  marginBottom: 20,
                  border: "2px solid #07C756",
                  position: "relative",
                  overflow: "hidden",
                }}
              >
                <div
                  style={{
                    position: "absolute",
                    top: -15,
                    right: -15,
                    width: 60,
                    height: 60,
                    borderRadius: "50%",
                    background: "rgba(7, 199, 86, 0.2)",
                  }}
                />
                <div
                  style={{
                    fontSize: 18,
                    fontWeight: 600,
                    color: "#07C756",
                    marginBottom: 20,
                    position: "relative",
                    zIndex: 1,
                  }}
                >
                  รหัส OTP ของคุณ
                </div>
                <div
                  style={{
                    fontSize: 64,
                    fontWeight: 800,
                    color: "#07C756",
                    letterSpacing: "10px",
                    textShadow: "0 4px 8px rgba(7, 199, 86, 0.3)",
                    position: "relative",
                    zIndex: 1,
                  }}
                >
                  {verifyData?.otp}
                </div>
              </div>

              {/* Warning for Golfer */}
              <div
                style={{
                  background:
                    "linear-gradient(135deg, #fff8e1 0%, #fffde7 100%)",
                  border: "2px solid #ffb74d",
                  borderRadius: 12,
                  padding: 8,
                  marginBottom: 20,
                }}
              >
                <div
                  style={{
                    color: "#ef6c00",
                    fontSize: 12,
                    fontWeight: 600,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: 8,
                  }}
                >
                  กรุณาเปิดหน้าจอไว้ระหว่างแคดดี้เช็คอิน
                </div>
              </div>

              {/* Info Section for Golfer */}
              <div
                style={{
                  background:
                    "linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)",
                  borderRadius: 12,
                  padding: 12,
                  border: "1px solid #dee2e6",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 8,
                    fontSize: 14,
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: 8,
                      fontWeight: 600,
                      color: "#495057",
                    }}
                  >
                    🔑 <span>Ref Code : {verifyData?.otp_ref}</span>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: 8,
                      fontSize: 12,
                      fontWeight: 600,
                      color: timeLeft?.minutes < 2 ? "#a93346" : "#495057",
                    }}
                  >
                    <span style={{ fontSize: 12 }}>
                      เช็คอินภายใน :{" "}
                      {timeLeft.minutes.toString().padStart(2, "0")} นาที{" "}
                      {timeLeft.seconds.toString().padStart(2, "0")} วินาที
                    </span>
                  </div>
                </div>
              </div>
            </div>
          )
        ) : (
          <div
            style={{
              textAlign: "center",
              background: "linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)",
              borderRadius: 16,
              padding: 32,
              border: "1px solid #dee2e6",
              position: "relative",
              zIndex: 1,
            }}
          >
            <div
              style={{
                fontSize: 18,
                color: "#495057",
                fontWeight: 500,
              }}
            >
              <LoadingOutlined style={{ marginRight: 8 }} />
              กำลังโหลดหมายเลข OTP...
            </div>
          </div>
        )}
      </div>
    );
  }

  async function createCaddyOTP() {
    try {
      const { data, status } = await api.bookingApi.createCaddyChallenge(
        booking?.id,
        { booking_id: booking?.id, is_otp: true },
        false,
      );
      if (status === 201) {
        setVerifyData(data?.data);
        setVerifyMethod(2);
      }
    } catch (error) {
      console.log("err", error);
      setVerifyMethod(0);
    }
  }

  async function createCaddyQrCode() {
    try {
      const { data, status } = await api.bookingApi.createCaddyChallenge(
        booking?.id,
        { booking_id: booking?.id, is_otp: false },
        false,
      );
      if (status === 201) {
        setVerifyData(data?.data);
        setVerifyMethod(1);
      }
    } catch (error) {
      console.log("err", error);
      setVerifyMethod(0);
    } finally {
      setIsLoading(false);
    }
  }

  async function getCaddyOTP(is_qr = false) {
    try {
      const { data, status } = await api.bookingApi.getCaddyChallenge(
        booking?.id,
        {
          is_qr: is_qr,
        },
      );
      if (status === 200) {
        setVerifyData(data?.data);
        setVerifyMethod(is_qr ? 1 : 2);
      }
    } catch (error) {
      console.log("err", error);
      setVerifyMethod(0);
      setIsLoading(false);
    }
  }

  function checkInSuccess() {
    return (
      <Fragment>
        <b style={{ color: "#0D60F9", fontSize: 18 }}>เช็คอิน</b>
        <div style={{ color: "#757575", fontSize: 16, marginTop: 5 }}>
          {verifyData?.otp ? "OTP" : "QR Code"}
        </div>

        <center>
          <CheckCircleFilled style={{ fontSize: 84, color: "#2196f3" }} />
          <div style={{ fontSize: 18 }}>
            <div style={{ marginTop: 15 }}>เช็คอินสำเร็จ</div>
            <b style={{ marginTop: 10 }}>Ref Code : {verifyData?.otp_ref}</b>
          </div>
        </center>
      </Fragment>
    );
  }

  async function handleOnVerifyQRCode(result) {
    if (!result || (result?.id && booking?.id && result.id !== booking?.id)) {
      messageApi.open({
        type: "error",
        content: "QR Code ไม่ตรงกัน.",
      });

      setVerifyMethod(4);
      setIsScanning(false);
      return;
    }

    try {
      const { status } = await api.bookingApi.verifyCaddy(
        {
          booking_id: booking?.id,
          otp_ref: verifyData?.otp_ref,
          is_otp: false,
        },
        false,
      );
      if (status === 201) {
        setIsLoading(true);

        setTimeout(() => {
          messageApi.open({
            type: "success",
            content: "ทำการยืนยันสำเร็จแล้ว.",
          });

          GetBookingList();
          setVerifyMethod(3);
          setOTPNumber(null);
          setTimeLeft(null);
          clearInterval(timer);
        }, 2000);
      } else {
        messageApi.open({
          type: "error",
          content: booking?.error,
        });
        setVerifyMethod(4);
      }
    } catch (error) {
      messageApi.open({
        type: "error",
        content: booking?.error,
      });
      setVerifyMethod(4);
      console.log("err", error);
    }
  }

  async function handleOnVerifyOTP() {
    if (!otpNumber) {
      setOTPNumberError(true);
      return;
    }
    try {
      const { data, status } = await api.bookingApi.verifyCaddy(
        {
          booking_id: booking?.id,
          otp_number: otpNumber,
          otp_ref: verifyData?.otp_ref,
          is_otp: true,
        },
        false,
      );
      if (status === 201) {
        setIsLoading(true);

        setTimeout(() => {
          messageApi.open({
            type: "success",
            content: "ทำการยืนยันสำเร็จแล้ว.",
          });

          GetBookingList();
          setVerifyMethod(3);
          setOTPNumber(null);
          setTimeLeft(null);
          clearInterval(timer);
        }, 2000);
      } else {
        messageApi.open({
          type: "error",
          content: booking?.error,
        });
        setVerifyMethod(4);
      }
    } catch (error) {
      console.log("err", error);
      messageApi.open({
        type: "error",
        content: booking?.error,
      });
      setVerifyMethod(4);
    }
  }

  function SelectMethod() {
    let allow_check_in = false;
    let over_time = false;
    const now = dayjs();

    if (booking?.tf_date && booking?.tf_time) {
      const date = dayjs(booking.tf_date);
      const start = dayjs(booking.tf_time);
      const end = booking?.tf_time_end ? dayjs(booking.tf_time_end) : null;
      const checkinStart = start.subtract(30, "minutes");

      if (now.isSame(date, "day") && now.isAfter(checkinStart)) {
        allow_check_in = true;
      }
      if (end && now.isAfter(end) && now.isSame(date, "day")) {
        over_time = true;
        allow_check_in = false;
      }
    }

    return !allow_check_in ? (
      <div
        style={{
          background: "linear-gradient(135deg, #fffdf7 0%, #ffffff 100%)",
          borderRadius: 20,
          position: "relative",
          overflow: "hidden",
        }}
      >
        {/* Decorative elements */}
        <div
          style={{
            position: "absolute",
            top: -30,
            right: -30,
            width: 100,
            height: 80,
            borderRadius: "50%",
            background: over_time
              ? "linear-gradient(135deg, #dc3545 0%, #e74c3c 100%)"
              : "linear-gradient(135deg, #f59e0b 0%, #fbbf24 100%)",
            opacity: 0.15,
          }}
        />
        <div
          style={{
            position: "absolute",
            bottom: -20,
            left: -20,
            width: 60,
            height: 60,
            borderRadius: "50%",
            background: "linear-gradient(135deg, #eab308 0%, #facc15 100%)",
            opacity: 0.1,
          }}
        />

        {/* Header */}
        <div
          style={{
            textAlign: "center",
            marginBottom: 24,
            position: "relative",
            zIndex: 1,
          }}
        >
          <div
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: 10,
              background: over_time
                ? "linear-gradient(135deg, #dc3545 0%, #e74c3c 100%)"
                : "linear-gradient(135deg, #f59e0b 0%, #fbbf24 100%)",
              color: "white",
              padding: "8px 14px",
              borderRadius: 20,
              fontSize: 18,
              fontWeight: 600,
              boxShadow: over_time
                ? "0 4px 12px rgba(220, 53, 69, 0.3)"
                : "0 4px 12px rgba(245, 158, 11, 0.3)",
            }}
          >
            {over_time ? "⏰" : "🕐"} เช็คอิน
          </div>
        </div>

        {/* Status Message */}
        <div
          style={{
            textAlign: "center",
            background: over_time
              ? "linear-gradient(135deg, #ffebee 0%, #fce4ec 100%)"
              : "linear-gradient(135deg, #fffbeb 0%, #fef3c7 100%)",
            borderRadius: 16,
            padding: 16,
            border: over_time ? "2px solid #ffcdd2" : "2px solid #fde68a",
            position: "relative",
            zIndex: 1,
            marginBottom: 20,
          }}
        >
          <div
            style={{
              color: over_time ? "#a93346" : "#b45309",
              fontSize: 18,
              fontWeight: 700,
              marginBottom: 16,
              lineHeight: 1.4,
            }}
          >
            {over_time
              ? "หมดเวลาเช็คอิน ให้แคดดี้ติดต่อเจ้าหน้าที่"
              : "ยังไม่ถึงเวลาเช็คอิน"}
          </div>

          {booking?.tf_time && (
            <div
              style={{
                background: "linear-gradient(135deg, #ffffff 0%, #fffdf7 100%)",
                borderRadius: 12,
                padding: 12,
                border: "1px solid #fbbf24",
                marginBottom: 20,
              }}
            >
              <div
                style={{
                  color: "#78350f",
                  fontSize: 14,
                  marginBottom: 8,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 8,
                }}
              >
                📅 วันที่ : {dayjs(booking?.tf_time).format("DD")}{" "}
                {
                  THAI_MONTHS[
                    parseInt(dayjs(booking?.tf_time).format("MM")) - 1
                  ]
                }{" "}
                {dayjs(booking?.tf_time).format("YYYY")}
              </div>
              <div
                style={{
                  color: "#78350f",
                  fontSize: 14,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 8,
                }}
              >
                ⏰ เวลาเช็คอิน :{" "}
                {dayjs(booking?.tf_time, "YYYY-MM-DD HH:mm:ss")
                  .add(7, "hours")
                  .format("HH:mm")}{" "}
                -{" "}
                {dayjs(booking?.tf_time, "YYYY-MM-DD HH:mm:ss")
                  .add(13, "hours")
                  .format("HH:mm")}{" "}
                น.
              </div>
            </div>
          )}

          <div
            style={{
              width: 100,
              height: 100,
              borderRadius: "50%",
              backgroundColor: over_time
                ? "rgba(220, 53, 69, 0.1)"
                : "rgba(245, 158, 11, 0.15)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "0 auto",
              border: over_time
                ? "3px solid rgba(220, 53, 69, 0.2)"
                : "3px solid rgba(245, 158, 11, 0.3)",
            }}
          >
            <ClockCircleFilled
              style={{
                fontSize: 50,
                color: over_time ? "#dc3545" : "#f59e0b",
              }}
            />
          </div>
        </div>
      </div>
    ) : (
      <div
        style={{
          background: "linear-gradient(135deg, #fffdf7 0%, #ffffff 100%)",
          borderRadius: 20,
          padding: "24px",
          position: "relative",
          overflow: "hidden",
        }}
      >
        {/* Decorative elements */}
        <div
          style={{
            position: "absolute",
            top: -30,
            right: -30,
            width: 80,
            height: 80,
            borderRadius: "50%",
            background: "linear-gradient(135deg, #f59e0b 0%, #fbbf24 100%)",
            opacity: 0.15,
          }}
        />
        <div
          style={{
            position: "absolute",
            bottom: -20,
            left: -20,
            width: 60,
            height: 60,
            borderRadius: "50%",
            background: "linear-gradient(135deg, #eab308 0%, #facc15 100%)",
            opacity: 0.1,
          }}
        />

        {/* Header */}
        <div
          style={{
            textAlign: "center",
            marginBottom: 24,
            position: "relative",
            zIndex: 1,
          }}
        >
          <div
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: 10,
              background: "linear-gradient(135deg, #f59e0b 0%, #fbbf24 100%)",
              color: "white",
              padding: "8px 16px",
              borderRadius: 20,
              fontSize: 18,
              fontWeight: 600,
              boxShadow: "0 4px 12px rgba(245, 158, 11, 0.3)",
            }}
          >
            เช็คอิน
          </div>
          <div
            style={{
              fontSize: 16,
              color: "#78350f",
              marginTop: 8,
              fontWeight: 500,
            }}
          >
            โปรดเลือกวิธีการเช็คอิน
          </div>
        </div>

        {/* Method Selection */}
        {userData.user_type === 0 ? (
          <div
            style={{
              display: "flex",
              gap: 16,
              alignItems: "stretch",
              justifyContent: "center",
              position: "relative",
              zIndex: 1,
            }}
          >
            <div
              onClick={() => {
                setIsScanning(false);
                getCaddyOTP(true);
              }}
              style={{
                flex: 1,
                background: "linear-gradient(135deg, #ffffff 0%, #fffdf7 100%)",
                borderRadius: 16,
                padding: "20px 16px",
                border: "2px solid #fde68a",
                cursor: "pointer",
                transition: "all 0.3s ease",
                textAlign: "center",
                boxShadow: "0 2px 8px rgba(245, 158, 11, 0.08)",
              }}
              onMouseEnter={(e) => {
                e.target.style.transform = "translateY(-4px)";
                e.target.style.boxShadow = "0 8px 16px rgba(245, 158, 11, 0.2)";
                e.target.style.borderColor = "#f59e0b";
                e.target.style.background =
                  "linear-gradient(135deg, #fffbeb 0%, #fef3c7 100%)";
              }}
              onMouseLeave={(e) => {
                e.target.style.transform = "translateY(0)";
                e.target.style.boxShadow = "0 2px 8px rgba(245, 158, 11, 0.08)";
                e.target.style.borderColor = "#fde68a";
                e.target.style.background =
                  "linear-gradient(135deg, #ffffff 0%, #fffdf7 100%)";
              }}
            >
              <div style={{ marginBottom: 12 }}>
                <Image
                  preview={false}
                  src={scanQrImage}
                  style={{
                    maxWidth: "60px",
                    maxHeight: "60px",
                    objectFit: "contain",
                  }}
                />
              </div>
              <div
                style={{
                  fontSize: 16,
                  fontWeight: 600,
                  color: "#78350f",
                }}
              >
                Scan QR
              </div>
            </div>

            <div
              onClick={() => getCaddyOTP()}
              style={{
                flex: 1,
                background: "linear-gradient(135deg, #ffffff 0%, #fffdf7 100%)",
                borderRadius: 16,
                padding: "20px 16px",
                border: "2px solid #fde68a",
                cursor: "pointer",
                transition: "all 0.3s ease",
                textAlign: "center",
                boxShadow: "0 2px 8px rgba(245, 158, 11, 0.08)",
              }}
              onMouseEnter={(e) => {
                e.target.style.transform = "translateY(-4px)";
                e.target.style.boxShadow = "0 8px 16px rgba(234, 179, 8, 0.2)";
                e.target.style.borderColor = "#eab308";
                e.target.style.background =
                  "linear-gradient(135deg, #fffbeb 0%, #fef3c7 100%)";
              }}
              onMouseLeave={(e) => {
                e.target.style.transform = "translateY(0)";
                e.target.style.boxShadow = "0 2px 8px rgba(245, 158, 11, 0.08)";
                e.target.style.borderColor = "#fde68a";
                e.target.style.background =
                  "linear-gradient(135deg, #ffffff 0%, #fffdf7 100%)";
              }}
            >
              <div style={{ marginBottom: 12 }}>
                <Image
                  preview={false}
                  src={otpImage}
                  style={{
                    maxWidth: "60px",
                    maxHeight: "60px",
                    objectFit: "contain",
                  }}
                />
              </div>
              <div
                style={{
                  fontSize: 16,
                  fontWeight: 600,
                  color: "#78350f",
                }}
              >
                ใส่ OTP
              </div>
            </div>
          </div>
        ) : (
          <div
            style={{
              display: "flex",
              gap: 16,
              alignItems: "stretch",
              justifyContent: "center",
              position: "relative",
              zIndex: 1,
            }}
          >
            <div
              onClick={() => createCaddyQrCode()}
              style={{
                flex: 1,
                background: "linear-gradient(135deg, #ffffff 0%, #fffdf7 100%)",
                borderRadius: 16,
                padding: "20px 16px",
                border: "2px solid #fde68a",
                cursor: "pointer",
                transition: "all 0.3s ease",
                textAlign: "center",
                boxShadow: "0 2px 8px rgba(245, 158, 11, 0.08)",
              }}
              onMouseEnter={(e) => {
                e.target.style.transform = "translateY(-4px)";
                e.target.style.boxShadow = "0 8px 16px rgba(245, 158, 11, 0.2)";
                e.target.style.borderColor = "#f59e0b";
                e.target.style.background =
                  "linear-gradient(135deg, #fffbeb 0%, #fef3c7 100%)";
              }}
              onMouseLeave={(e) => {
                e.target.style.transform = "translateY(0)";
                e.target.style.boxShadow = "0 2px 8px rgba(245, 158, 11, 0.08)";
                e.target.style.borderColor = "#fde68a";
                e.target.style.background =
                  "linear-gradient(135deg, #ffffff 0%, #fffdf7 100%)";
              }}
            >
              <div style={{ marginBottom: 12 }}>
                <Image
                  preview={false}
                  src={qrCheckingImage}
                  style={{
                    maxWidth: "60px",
                    maxHeight: "60px",
                    objectFit: "contain",
                  }}
                />
              </div>
              <div
                style={{
                  fontSize: 12,
                  fontWeight: 600,
                  color: "#78350f",
                }}
              >
                เปิด QR
              </div>
            </div>

            <div
              onClick={() => {
                createCaddyOTP();
              }}
              style={{
                flex: 1,
                background: "linear-gradient(135deg, #ffffff 0%, #fffdf7 100%)",
                borderRadius: 16,
                padding: "20px 16px",
                border: "2px solid #fde68a",
                cursor: "pointer",
                transition: "all 0.3s ease",
                textAlign: "center",
                boxShadow: "0 2px 8px rgba(245, 158, 11, 0.08)",
              }}
              onMouseEnter={(e) => {
                e.target.style.transform = "translateY(-4px)";
                e.target.style.boxShadow = "0 8px 16px rgba(234, 179, 8, 0.2)";
                e.target.style.borderColor = "#eab308";
                e.target.style.background =
                  "linear-gradient(135deg, #fffbeb 0%, #fef3c7 100%)";
              }}
              onMouseLeave={(e) => {
                e.target.style.transform = "translateY(0)";
                e.target.style.boxShadow = "0 2px 8px rgba(245, 158, 11, 0.08)";
                e.target.style.borderColor = "#fde68a";
                e.target.style.background =
                  "linear-gradient(135deg, #ffffff 0%, #fffdf7 100%)";
              }}
            >
              <div style={{ marginBottom: 12 }}>
                <Image
                  preview={false}
                  src={otpImage}
                  style={{
                    maxWidth: "60px",
                    maxHeight: "60px",
                    objectFit: "contain",
                  }}
                />
              </div>
              <div
                style={{
                  fontSize: 12,
                  fontWeight: 600,
                  color: "#78350f",
                }}
              >
                สร้าง OTP
              </div>
            </div>
          </div>
        )}
        <CheckinPolicy />
      </div>
    );
  }

  function checkInError() {
    return (
      <div
        style={{
          background: "linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%)",
          borderRadius: 20,
          padding: "24px",
          position: "relative",
          overflow: "hidden",
        }}
      >
        {/* Decorative elements */}
        <div
          style={{
            position: "absolute",
            top: -30,
            right: -30,
            width: 80,
            height: 80,
            borderRadius: "50%",
            background: "linear-gradient(135deg, #a93346 0%, #d63384 100%)",
            opacity: 0.1,
          }}
        />
        <div
          style={{
            position: "absolute",
            bottom: -20,
            left: -20,
            width: 60,
            height: 60,
            borderRadius: "50%",
            background: "linear-gradient(135deg, #dc3545 0%, #e74c3c 100%)",
            opacity: 0.1,
          }}
        />

        {/* Header */}
        <div
          style={{
            textAlign: "center",
            marginBottom: 24,
            position: "relative",
            zIndex: 1,
          }}
        >
          <div
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: 10,
              background: "linear-gradient(135deg, #a93346 0%, #d63384 100%)",
              color: "white",
              padding: "8px 16px",
              borderRadius: 20,
              fontSize: 18,
              fontWeight: 600,
              boxShadow: "0 4px 12px rgba(169, 51, 70, 0.3)",
            }}
          >
            เช็คอิน
          </div>
          <div
            style={{
              fontSize: 16,
              color: "#6c757d",
              marginTop: 8,
              fontWeight: 500,
            }}
          >
            {verifyData?.is_otp ? "หมายเลข OTP" : "แสกน QR Code"}
          </div>
        </div>

        {/* Error Content */}
        <div
          style={{
            textAlign: "center",
            background: "linear-gradient(135deg, #ffebee 0%, #fce4ec 100%)",
            borderRadius: 16,
            padding: 32,
            border: "2px solid #ffcdd2",
            position: "relative",
            zIndex: 1,
            boxShadow: "0 4px 12px rgba(220, 53, 69, 0.15)",
          }}
        >
          <div
            style={{
              width: 80,
              height: 80,
              borderRadius: "50%",
              backgroundColor: "rgba(220, 53, 69, 0.1)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "0 auto 24px",
              border: "3px solid rgba(220, 53, 69, 0.2)",
            }}
          >
            <CloseCircleFilled style={{ fontSize: 40, color: "#dc3545" }} />
          </div>

          <div
            style={{
              color: "#a93346",
              fontSize: 22,
              fontWeight: 700,
              marginBottom: 16,
              lineHeight: 1.4,
            }}
          >
            เช็คอินไม่สำเร็จ
          </div>

          <div
            style={{
              background: "linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)",
              borderRadius: 12,
              padding: 20,
              marginBottom: 20,
              border: "1px solid #dee2e6",
            }}
          >
            <div
              style={{
                color: "#495057",
                fontSize: 16,
                lineHeight: 1.6,
                marginBottom: 16,
              }}
            >
              {verifyData?.is_otp ? "OTP" : "QR Code"} ไม่ถูกต้อง
              <br />
              โปรดเช็ค Booking Code ให้ตรงกัน
            </div>
            <div
              style={{
                background: "linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)",
                borderRadius: 8,
                padding: 12,
                fontSize: 14,
                fontWeight: 600,
                color: "#495057",
              }}
            >
              Ref Code : {verifyData?.otp_ref}
            </div>
          </div>

          {/* Try Again Button */}
          <div
            style={{
              background: "linear-gradient(135deg, #fff8e1 0%, #fffde7 100%)",
              border: "2px solid #ffb74d",
              borderRadius: 12,
              padding: 16,
              textAlign: "center",
            }}
          >
            <div
              style={{
                color: "#ef6c00",
                fontSize: 16,
                fontWeight: 600,
                lineHeight: 1.5,
              }}
            >
              กรุณาลองใหม่อีกครั้ง หรือติดต่อเจ้าหน้าที่
            </div>
          </div>
        </div>
      </div>
    );
  }

  const VERIFY_PAGE = [
    SelectMethod(),
    QrCodePage(),
    OTPPage(),
    checkInSuccess(),
    checkInError(),
  ];

  return (
    <div style={{ marginBottom: 10, position: "relative" }}>
      {contextHolder}
      <CancelModal />
      {booking?.tf_time && (
        <h3>
          {dayjs(booking?.tf_time).format("DD")}{" "}
          {THAI_MONTHS[parseInt(dayjs(booking?.tf_time).format("MM")) - 1]}{" "}
          {dayjs(booking?.tf_time).format("YYYY")}
        </h3>
      )}
      <div className="job-card-container">
        {userData?.user_type === 1 && status_key === "history" && (
          <div
            onClick={() => onClickDelete(false, [booking?.id])}
            style={{
              position: "absolute",
              top: 10,
              right: 10,
              padding: "10px 10px",
              background: "red",
              borderRadius: "10px",
              fontSize: 14,
              color: "white",
            }}
          >
            <DeleteFilled /> ลบ
          </div>
        )}
        {booking?.status === 2 ? (
          booking?.is_verify ? (
            <div
              style={{
                position: "absolute",
                bottom: 10,
                right: 10,
                borderRadius: 10,
                textAlign: "center",
                padding: 12,
                fontSize: 16,
              }}
            >
              <CheckCircleFilled style={{ fontSize: 32, color: "#14AE5C" }} />
              <div>เช็คอินแล้ว</div>
            </div>
          ) : (
            <div
              onClick={() => setIsCheckIn(true)}
              style={{
                position: "absolute",
                bottom: 10,
                right: 10,
                borderRadius: 10,
                background: "#07C756",
                color: "white",
                padding: 12,
                fontSize: 16,
              }}
            >
              เช็คอิน
            </div>
          )
        ) : (
          <Fragment />
        )}
        {isCheckIn && (
          <div className="check-in-container">
            <div className="check-in-content">
              <CloseOutlined
                onClick={() => {
                  if (verifyMethod > 0 && verifyMethod <= 2) setVerifyMethod(0);
                  else setIsCheckIn(false);

                  setVerifyMethod(0);
                  setOTPNumber(null);
                  setTimeLeft(null);
                  clearInterval(timer);
                }}
                style={{
                  fontSize: 20,
                  position: "absolute",
                  top: 10,
                  right: 10,
                }}
              />
              {VERIFY_PAGE[verifyMethod]}
            </div>
          </div>
        )}
        {booking?.status === 2 && !booking?.is_verify ? (
          <Popover content={cancel_content} trigger="click" placement="bottom">
            <div
              style={{
                position: "absolute",
                right: 20,
                top: 20,
                display: "flex",
                gap: 2,
                cursor: "pointer",
              }}
            >
              <div className="more-icon" />
              <div className="more-icon" />
              <div className="more-icon" />
            </div>
          </Popover>
        ) : (
          <Fragment />
        )}

        {(() => {
          const getBadgeConfig = () => {
            const isRollUpUsed =
              booking?.roll_up_used &&
              booking?.status === 7 &&
              userData.user_type === 1;
            const isStatusOverFive =
              booking?.status > 5 && userData.user_type === 0;
            const isWaitingConfirm =
              booking?.status === 0 && !booking?.qr_expire;

            if (isRollUpUsed) {
              return {
                color: "gray",
                icon: <CheckOutlined style={{ color: "gray" }} />,
                label: "จองใหม่แล้ว",
              };
            }

            if (isWaitingConfirm) {
              return {
                color: badge_status[0]?.color,
                icon: <EllipsisOutlined style={{ fontSize: 20 }} />,
                label: "รอยืนยัน",
              };
            }

            if (isStatusOverFive) {
              return {
                color: badge_status[5]?.color,
                icon: badge_status[5]?.icon,
                label: badge_status[5]?.label,
              };
            }

            return {
              color: badge_status[booking?.status]?.color,
              icon: badge_status[booking?.status]?.icon,
              label: badge_status[booking?.status]?.label ?? "BADGE",
            };
          };

          const badgeConfig = getBadgeConfig();

          return (
            <div
              className="job-card-badge"
              style={{
                color: badgeConfig.color,
                border: `2px solid ${badgeConfig.color || "black"}`,
              }}
            >
              {badgeConfig.icon} {badgeConfig.label}
            </div>
          );
        })()}

        <center>
          <div
            style={{
              borderRadius: "50%",
              backgroundImage: `url(${booking?.profile_url})`,
              height: 200,
              width: 200,
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
            }}
          />
        </center>

        <Divider style={{ margin: "15px 0px" }} />

        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginBottom: 15,
          }}
        >
          <b style={{ fontSize: 18 }}>
            {booking?.data?.user?.display_name}{" "}
            {userData?.user_type === 1 && (
              <span style={{ fontSize: 14, color: "#FF8C00" }}>
                (เบอร์: <span>{booking?.data?.user?.caddy_number}</span>)
              </span>
            )}
          </b>
        </div>

        {userData?.user_type === 1 && (
          <div
            style={{
              fontSize: 16,
              marginBottom: 10,
              fontWeight: "bold",
              color: "#007AFF",
            }}
          >
            {booking?.data?.golfcourse?.name}
          </div>
        )}
        <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
          {booking?.tf_time && (
            <>
              <div>
                วันที่ ทีออฟ : {dayjs(booking?.tf_time).format("DD")}{" "}
                {
                  THAI_MONTHS[
                    parseInt(dayjs(booking?.tf_time).format("MM")) - 1
                  ]
                }{" "}
                {dayjs(booking?.tf_time).format("YYYY")}
              </div>
              <div>
                เวลา ทีออฟ :{" "}
                {dayjs(booking?.tf_time, "YYYY-MM-DD HH:mm:ss")
                  .add(7, "hours")
                  .format("HH:mm")}{" "}
                -{" "}
                {dayjs(booking?.tf_time, "YYYY-MM-DD HH:mm:ss")
                  .add(13, "hours")
                  .format("HH:mm")}{" "}
                น.
              </div>
            </>
          )}
          {booking?.play_mode && (
            <div>
              รูปแบบการเล่น (Play) :{" "}
              {PLAY_MODE_LABELS[booking?.play_mode] || "-"}
            </div>
          )}
          <b style={{ paddingRight: 60 }}>
            หมายเลขการจอง : {booking?.booking_ref || "N/A"}
          </b>
          {booking?.booking_note && (
            <div style={{ marginTop: 5, color: "#555", fontSize: 14 }}>
              📝 หมายเหตุ : {booking?.booking_note}
            </div>
          )}
        </div>
        <div
          style={{
            fontSize: 20,
            marginTop: 10,
            fontWeight: "bold",
            color: "#007AFF",
            display: "flex",
            flexDirection: "column",
          }}
        >
          ทิป{" "}
          {new Intl.NumberFormat("th-TH", {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
          }).format(booking?.fee)}{" "}
          บาท
          <span
            style={{ fontSize: 12, color: "black" }}
          >{`   (ยังไม่รวมค่า FEE + VAT)`}</span>
        </div>
        {userData?.user_type === 1 &&
          booking?.status === 4 &&
          !booking?.is_review && (
            <Button
              type="primary"
              style={{
                width: "100%",
                height: 40,
                marginTop: 10,
                marginBottom: 5,
              }}
            >
              <div
                onClick={() => navigate(`/review/${booking?.id}`)}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "100%",
                  gap: 5,
                }}
              >
                <StarOutlined style={{ fontSize: 20 }} />
                <div>รีวิว</div>
              </div>
            </Button>
          )}

        {userData?.user_type === 1 && status_key === "history" && (
          <>
            <Divider style={{ margin: 5, marginTop: 10 }} />
            <div
              onClick={() => naviage(`/book_caddy/${booking?.caddy_id}`)}
              style={{
                display: "flex",
                gap: 10,
                alignItems: "center",
                justifyContent: "center",
                fontSize: 16,
                marginTop: 20,
              }}
            >
              <RedoOutlined /> จองอีกครั้ง
            </div>
          </>
        )}
        {userData.user_type === 1 &&
        booking?.status === 5 &&
        booking?.is_refund &&
        !booking?.refuned ? (
          <div
            onClick={() =>
              naviage(`/book_caddy/${booking?.caddy_id}/${booking?.id}`)
            }
            style={{
              cursor: "pointer",
              borderRadius: 10,
              padding: "15px 15px",
              backgroundColor: "black",
              color: "white",
              position: "absolute",
              bottom: 10,
              right: 10,
            }}
          >
            รับเงินคืน
          </div>
        ) : (
          <Fragment />
        )}
        {booking?.status === 0 && (
          <div style={{ color: "red", marginTop: 10 }}>
            ยืนยันภายใน :{" "}
            {dayjs(booking?.caddy_accept_expire_at).format("DD-MM-YYYY HH:mm")}
          </div>
        )}
        {userData?.user_type === 0 &&
          booking?.status === 0 &&
          !booking?.qr_expire && (
            <div
              style={{ width: "100%", display: "flex", gap: 20, marginTop: 20 }}
            >
              <Button
                color="#4c7bf6"
                style={{
                  width: "100%",
                  backgroundColor: "#4c7bf6",
                  color: "white",
                  height: 45,
                }}
                onClick={() => {
                  setBookingToAcceptOrReject({
                    data: booking,
                    is_accept: true,
                  });
                  setIsAcceptOrReject(true);
                }}
              >
                ยอมรับ
              </Button>
              <Button
                onClick={() => {
                  setBookingToAcceptOrReject({
                    data: booking,
                    is_accept: false,
                  });
                  setIsAcceptOrReject(true);
                }}
                style={{ width: "100%", height: 45 }}
                danger
                type="primary"
              >
                ปฏิเสธ
              </Button>
            </div>
          )}
      </div>
      <Divider />
    </div>
  );
}
